import React, { SVGProps } from 'react';

const BrokenPipeIcon: React.FC<SVGProps<SVGSVGElement>> = ({ ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="60"
    height="60"
    viewBox="0 0 60 60"
    fill="none"
    {...props}
  >
    <g clipPath="url(#clip0_214_16252)">
      <path
        d="M18.3804 41.7443L26.2729 46.4676C20.9313 43.6864 24.0522 51.8681 24.0522 53.8358C24.0522 58.0055 18.3808 57.6582 18.3808 53.8358C18.3808 50.0134 23.3958 45.0593 18.3804 41.7443Z"
        fill="#DDB96E"
      />
      <path
        d="M18.3804 41.7443L26.2729 46.4676C24.665 45.6304 23.8238 45.7866 23.4336 46.4676L20.5811 44.9836C20.449 43.8107 19.8387 42.7082 18.3804 41.7443Z"
        fill="#BB9446"
      />
      <path
        d="M4.71578 15.0159C0.264033 22.7266 1.62537 31.8468 7.75641 35.3866L36.4314 52.5562L52.8826 24.8421L23.8776 7.46386C17.7466 3.92411 9.16752 7.30528 4.71578 15.0159Z"
        fill="#F9E4B9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.64486 15.1399C0.278875 22.8241 1.65834 31.8657 7.75653 35.3865L36.4315 52.5562L44.6938 38.6373L4.64486 15.1399Z"
        fill="#F2D497"
      />
      <ellipse
        cx="44.4488"
        cy="38.5748"
        rx="12.8186"
        ry="16.1212"
        transform="rotate(30 44.4488 38.5748)"
        fill="#DDB96E"
      />
      <ellipse
        cx="44.4489"
        cy="38.5748"
        rx="10.2549"
        ry="12.8969"
        transform="rotate(30 44.4489 38.5748)"
        fill="#7C612E"
      />
      <path
        d="M21.7036 35.4734L17.1904 37.0903L18.1199 41.5953L20.2524 42.8696L19.3744 38.2778L24.4681 36.3893L21.567 31.9146L23.4934 29.4836L19.0869 31.1715L21.7036 35.4734Z"
        fill="#7C612E"
      />
    </g>
    <defs>
      <clipPath id="clip0_214_16252">
        <rect width="60" height="60" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default BrokenPipeIcon;
